/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_CreateInputs */

const vi_tea_purchase_create = /** @type {(inputs: Tea_Purchase_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo đơn mua`)
};

/**

* @param {Tea_Purchase_CreateInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_create = /** @type {((inputs?: Tea_Purchase_CreateInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_CreateInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_create(inputs)
});